import { listIdForSearch } from "../helper";

export const teamsTopTalentsListActions = {
  FETCH_TEAMS_TOP_TALENTS_FAILED: 'FETCH_TEAMS_TOP_TALENTS_FAILED',
  FETCH_TEAMS_TOP_TALENTS_SUCCESS: 'FETCH_TEAMS_TOP_TALENTS_SUCCESS',
  FETCH_TEAMS_TOP_TALENTS_PENDING: 'FETCH_TEAMS_TOP_TALENTS_PENDING',
  LOAD_TEAM_TOP_TALENTS: 'LOAD_TEAM_TOP_TALENTS',

  fetchTeamsTopTalentsFailed: (error, teamId) => ({
    type: teamsTopTalentsListActions.FETCH_TEAMS_TOP_TALENTS_FAILED,
    payload: {
      error,
      teamId
    }
  }),

  fetchTeamsTopTalentsSuccess: (teamId, data) => ({
    type: teamsTopTalentsListActions.FETCH_TEAMS_TOP_TALENTS_SUCCESS,
    payload: {
      data,
      teamId
    }
  }),

  fetchTeamsTopTalentsPending: teamId => ({
    type: teamsTopTalentsListActions.FETCH_TEAMS_TOP_TALENTS_PENDING,
    payload: {
      teamId
    }
  }),

  loadTeamTopTalents: teamId => ({
    type: teamsTopTalentsListActions.LOAD_TEAM_TOP_TALENTS,
    payload: {
      teamId
    }
  })
};


export const teamsTopTalentsListRequestActions = {
  failed: teamsTopTalentsListActions.fetchTeamsTopTalentsFailed,
  success: teamsTopTalentsListActions.fetchTeamsTopTalentsSuccess,
  pending: teamsTopTalentsListActions.fetchTeamsTopTalentsPending
};
